export default {
  seconds: 0,
  lastDateTime: null,
  nextCloseSessionDate: null
}